import useSWR from "swr";

import { simpleFetcher } from "../fetcher";
import { type CategoryDetails } from "../types";

const url = "/api/v2/categories";

export function useCategoryDetails(id?: number, revalidateOnMount = false) {
  const { data, error, mutate } = useSWR<CategoryDetails, Error>(
    id ? `${url}/${id}/details` : null,
    simpleFetcher,
    {
      revalidateOnFocus: false,
      revalidateOnMount,
    },
  );
  return { data, error, mutate, isLoading: !data && !error };
}
